/**
 * @generated SignedSource<<dd2b69d39bf59463c679ab5751aa4ffb>>
 * @relayHash 4408fab74c35f89fa3b5fb5bb3ec8252
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a19f252493c8b47ac392631ca172d83edcc652de90d6be123efc05ce7f57ccfc

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateCoverPictureMutationBlogCreateMutation$variables = {
  blogPostId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateCoverPictureMutationBlogCreateMutation$data = {
  readonly confluence: {
    readonly createBlogPostProperty: {
      readonly blogPostProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateCoverPictureMutationBlogCreateMutation = {
  response: useUpdateCoverPictureMutationBlogCreateMutation$data;
  variables: useUpdateCoverPictureMutationBlogCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "blogPostId",
                "variableName": "blogPostId"
              },
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "propertyValue"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
        "kind": "LinkedField",
        "name": "createBlogPostProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "ConfluenceBlogPostProperty",
            "kind": "LinkedField",
            "name": "blogPostProperty",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateCoverPictureMutationBlogCreateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateCoverPictureMutationBlogCreateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "4408fab74c35f89fa3b5fb5bb3ec8252",
    "id": "a19f252493c8b47ac392631ca172d83edcc652de90d6be123efc05ce7f57ccfc",
    "metadata": {},
    "name": "useUpdateCoverPictureMutationBlogCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateCoverPictureMutationBlogCreateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{createBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{key,value}}}}"
  }
};
})();

(node as any).hash = "3d4ffd4b04a743fef61f9c35e898d663";

export default node;
